export const SHOPIFY_EMAIL_PAGE = 'onboarding/SHOPIFY_EMAIL_PAGE'
export const SHOPIFY_USER_PAGE = 'onboarding/SHOPIFY_USER_PAGE'
export const SHOPIFY_COMPANY_PAGE = 'onboarding/SHOPIFY_COMPANY_PAGE'
export const SHOPIFY_TRIAL_PAGE = 'onboarding/SHOPIFY_TRIAL_PAGE'
